import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVolumeUpStyle0 = cosmosIconCss;

const CosmosIconVolumeUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVolumeUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '375843bee0d9fd7f315d84c2ba952110dce394ff', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '36e307ad066395450ca8d544f7f8f0c61c7937d7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '540d293a6877b5154fb0aeed70a9cd63ebde66f9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.62 8 2.55-2.29a.5.5 0 0 1 .83.37v9.81a.5.5 0 0 1-.83.37L7.61 14H4.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h3.12Zm9.13.4v1.85h1.85c.22 0 .4.18.4.4v.7a.4.4 0 0 1-.4.4h-1.85v1.85a.4.4 0 0 1-.4.4h-.7a.4.4 0 0 1-.4-.4v-1.85H13.4a.4.4 0 0 1-.4-.4v-.7c0-.22.18-.4.4-.4h1.85V8.4c0-.22.18-.4.4-.4h.7c.22 0 .4.18.4.4Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVolumeUpStyle0; }
}, [1, "cosmos-icon-volume-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-volume-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-volume-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVolumeUp$1);
            }
            break;
    } });
}

const CosmosIconVolumeUp = CosmosIconVolumeUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVolumeUp, defineCustomElement };
